import { ReactElement } from "react";
import styles from "./styles.module.scss";

interface IProps {
  loader: ReactElement;
}

export const PageSizeLoader: FC<IProps> = ({ loader }) => {
  return <div className={styles.main}>{loader}</div>;
};
